export default __webpack_public_path__ + "static/Untitled-1-d6f9b82689fc19037d1f4a6a83a27a1e.png";